// exp_PORTFOLIO-61587_file
import { getVacancyOfTheDayForecast, VacancyOfTheDayPresetId } from 'utils/vacancyOfTheDay';

import {
    selectVacancyOfTheDayAreas,
    selectVacancyOfTheDayBudget,
    selectVacancyOfTheDayClicks,
    selectVacancyOfTheDayInitialAreas,
    selectVacancyOfTheDayInitialRoles,
    selectVacancyOfTheDayPreset,
    selectVacancyOfTheDayRoles,
    selectVacancyOfTheDayVacancy,
} from 'store/models/vacancyOfTheDay';
import { useSelector } from 'store/utils';

export const formatVacancyOfTheDayIds = (ids: number[]): string => ids.join(', ');

export const getVacancyOfTheDayIdSource = (current: number[], initial: number[]): 'from_vacancy' | 'added' | 'None' => {
    if (current.length === 0) {
        return 'None';
    }

    if (current.length !== initial.length) {
        return 'added';
    }

    const currentIds = [...current].sort((left, right) => left - right);
    const initialIds = [...initial].sort((left, right) => left - right);

    return currentIds.every((id, index) => id === initialIds[index]) ? 'from_vacancy' : 'added';
};

interface VacancyOfTheDayAnalyticsParams {
    vacancyId: number;
    preset: VacancyOfTheDayPresetId;
    budget: number;
    clicks: number;
    impressions: number;
    geoIds: string;
    roleIds: string;
}

export const useVacancyOfTheDayAnalyticsParams = (): {
    params: VacancyOfTheDayAnalyticsParams;
    initialAreas: number[];
    initialRoles: number[];
} => {
    const { vacancyId } = useSelector(selectVacancyOfTheDayVacancy);
    const areas = useSelector(selectVacancyOfTheDayAreas);
    const roles = useSelector(selectVacancyOfTheDayRoles);
    const preset = useSelector(selectVacancyOfTheDayPreset);
    const clicks = useSelector(selectVacancyOfTheDayClicks);
    const budget = useSelector(selectVacancyOfTheDayBudget);
    const initialAreas = useSelector(selectVacancyOfTheDayInitialAreas);
    const initialRoles = useSelector(selectVacancyOfTheDayInitialRoles);

    return {
        params: {
            vacancyId: vacancyId ?? 0,
            preset,
            budget,
            clicks,
            impressions: getVacancyOfTheDayForecast(clicks).impressions,
            geoIds: formatVacancyOfTheDayIds(areas),
            roleIds: formatVacancyOfTheDayIds(roles),
        },
        initialAreas,
        initialRoles,
    };
};
